import { render, staticRenderFns } from "./PassportReport.vue?vue&type=template&id=974545cc&scoped=true"
import script from "./PassportReport.vue?vue&type=script&lang=js"
export * from "./PassportReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "974545cc",
  null
  
)

export default component.exports